// extracted by mini-css-extract-plugin
module.exports = {"QuietPower":"QuietPower_QuietPower__5b52r"};